(ns frontend.view.grid.kyc-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce kyc-profiles (r/cursor app-db/views [:kyc-grid]))
(defonce modal-state (r/cursor kyc-profiles [:modals]))
(defonce grid-entities (r/cursor kyc-profiles [:grid-entities]))
(defonce view-settings (r/cursor kyc-profiles [:view-settings]))
(defonce kyc-profile-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor kyc-profiles [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor kyc-profiles [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor kyc-profiles [:schema]))
